import Head from 'next/head';
import React from 'react';
import Features from '../components/Business/SocialCommerceStack/Features/Features';
import Heading from '../components/Business/SocialCommerceStack/Heading/Heading';
import Navbar from '../components/Common/Navbar/Navbar';

const business = () => {
  return (
    <>
      <Head>
        <title>Social Commerce | Socommerz</title>
        <meta name="title" content="Social Commerce | Socommerz" />
        <meta name="description" content="Interact with your customers on popular Social channels like Instagram, Facebook, WhatsApp, Telegram, Web Bots etc to generate leads, boost revenue and engage with your customers." />
        <meta name="keywords"
          content="omni channel, interact with customer, engage with customer,bots,chat bot" />
        <meta name="robots" content="index,follow" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.socommerz.com/social-commerce/" />
        <meta property="og:title" content="Social Commerce | Socommerz" />
        <meta property="og:description" content="Interact with your customers on popular Social channels like Instagram, Facebook, WhatsApp, Telegram, Web Bots etc to generate leads, boost revenue and engage with your customers." />
        <link rel="canonical" href="https://www.socommerz.com/social-commerce/" />
        <link rel="alternate" href="https://www.socommerz.com/social-commerce/" hrefLang="en-in" />
        <meta property="twitter:url" content="https://www.socommerz.com/social-commerce/" />
        <meta property="twitter:title" content="Social Commerce | Socommerz" />
        <meta property="twitter:description" content="Interact with your customers on popular Social channels like Instagram, Facebook, WhatsApp, Telegram, Web Bots etc to generate leads, boost revenue and engage with your customers." />
      </Head>
      <main>
        <Heading />
        <Features />
      </main>
    </>
  );
};

export default business;
